
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class AssetEsperienzeDialog extends Serenity.EntityDialog<AssetEsperienzeRow, any> {
        protected getFormKey() { return AssetEsperienzeForm.formKey; }
        protected getIdProperty() { return AssetEsperienzeRow.idProperty; }
        protected getLocalTextPrefix() { return AssetEsperienzeRow.localTextPrefix; }
        protected getNameProperty() { return AssetEsperienzeRow.nameProperty; }
        protected getService() { return AssetEsperienzeService.baseUrl; }
        protected getDeletePermission() { return AssetEsperienzeRow.deletePermission; }
        protected getInsertPermission() { return AssetEsperienzeRow.insertPermission; }
        protected getUpdatePermission() { return AssetEsperienzeRow.updatePermission; }

        protected form = new AssetEsperienzeForm(this.idPrefix);

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();
           
            var buttonApply = Q.first(buttons, x => x.cssClass == "apply-changes-button");
            buttonApply.title = "Salva e continua";

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            //if (this.isCloneMode()) {
            //    Q.notifyInfo("Clone");
            //}
            //else if (this.isNew()) {
            //    Q.notifyInfo("Nuovo");
            //}
            //else {
            //    Q.notifyInfo("Modifica");
            //}

            if (this.isNew())
                this.saveAndCloseButton.hide();
            else
                this.saveAndCloseButton.show();

            this.form.ProdottiClassiList.ambito = ProdottiClassiAssetEsperienze2Editor.AmbitoEnum.VisualizzaProdottiClassi;
            this.form.ProdottiClassiList.idAssetEsperienza = this.entityId;

            this.form.RisorseList.ambito = AssetEsperienzeRisorse2Editor.AmbitoEnum.VisualizzaRisorse;
            this.form.RisorseList.idAssetEsperienza = this.entityId;

            this.form.ChecklistList.idAssetEsperienza = this.entityId;
        }

        loadEntity(entity: AssetEsperienzeRow) {
            super.loadEntity(entity);

            MyQ.hideEditorTab(this.form.ProdottiClassiList, this.isNewOrDeleted());
            MyQ.hideEditorTab(this.form.RisorseList, this.isNewOrDeleted());
            MyQ.hideEditorTab(this.form.ChecklistList, this.isNewOrDeleted());
        }

        protected isCloneMode(): boolean {
            return this.entity.IsCloned;
        }

        validateBeforeSave() {
            var bReturn = super.validateBeforeSave();

            if (bReturn) {
                if (!this.isNewOrDeleted() && this.form.ProdottiClassiList.getView().getItems().length == 0 ) {
                    Q.alert("L'asset non è stato associato a nessuna classe!");
                    bReturn = false;
                }
            }

            return bReturn;
        }

        onDialogClose() {
            if (!this.isNewOrDeleted() && this.form.ProdottiClassiList.getView().getItems().length == 0) {
                Q.warning("L'asset non è stato associato a nessuna classe!");
            }
        }

        onSaveSuccess() {
            this.dialogClose();
        }
    }
}
